import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.25 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ eyebrow, title, eyebrowTestId, titleTestId, center = false }) => (
  <Reveal className={center ? "text-center" : ""}>
    <p data-testid={eyebrowTestId} className="font-data text-xs sm:text-sm tracking-[0.28em] uppercase text-[#C9A24B] font-medium">
      {eyebrow}
    </p>
    <h2
      data-testid={titleTestId}
      className="mt-4 font-display font-bold tracking-tight text-[#FBF8F2] text-2xl sm:text-3xl lg:text-4xl leading-[1.15] max-w-3xl"
      style={center ? { marginLeft: "auto", marginRight: "auto" } : undefined}
    >
      {title}
    </h2>
  </Reveal>
);
